import { createSelector } from "reselect";

import { getBusinessLabels } from "./root";

export const getBusinessLabelById =
  (businessLabelId: string | null) => (state: RootState) =>
    getBusinessLabels(state)[businessLabelId] || null;

export const selectBusinessLabelsAggridData = createSelector(
  [getBusinessLabels],
  (businessLabelsByIdLookup: Record<string, BusinessLabel>) =>
    Object.values(businessLabelsByIdLookup),
);
